module.exports = __webpack_public_path__ + "img/24_41.bd05fd76.png";